import React from 'react';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/roboto'; 
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './session/authConfig';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

msalInstance.handleRedirectPromise().then(() => {
  root.render(
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </BrowserRouter>
  );
})

reportWebVitals();